<template>
    <b-container class="add-order">
        <!-- <b-toast title="Add a New Order" visible static no-auto-hide>
            Order has been added!
        </b-toast> -->
        <div class="loader" v-if="loader">
            <loader />
        </div>



        <div v-if="findCustomer" class="order-form">

            <h1>Add Order</h1>

            <!-- <b-row class="form-row" align-h="center" align-v="center">
                <b-col cols="4" sm="3">
                    <label for="business">Business</label>
                </b-col>
                <b-col cols="8" sm="9">
                    <b-form-input id="business" :readonly="true" type="text" v-model="business"></b-form-input>
                </b-col>
            </b-row> -->

            <!-- <b-row class="form-row" align-h="center" align-v="center">
                <b-col cols="4" sm="3">
                    <label for="start-time">Time</label>
                </b-col>
                <b-col cols="8" sm="9">
                    <b-form-input id="start-time" type="time" v-model="time"></b-form-input>
                </b-col>
            </b-row>

            <b-row class="form-row" align-h="center" align-v="center">
                <b-col cols="4" sm="3">
                    <label for="date">Date</label>
                </b-col>
                <b-col cols="8" sm="9">
                    <b-form-input id="date" type="date" v-model="date"></b-form-input>
                </b-col>
            </b-row> -->

            <b-row class="form-row" align-h="center" align-v="center">
                <b-col cols="4" sm="3">
                    <label for="customer">Customer</label>
                </b-col>
                <b-col cols="8" sm="9">
                    <b-form-input id="customer" type="text" v-model="customer"></b-form-input>
                </b-col>
            </b-row>

            <b-row class="form-row" align-h="center" align-v="center">
                <b-col cols="4" sm="3">
                    <label for="phone">Phone</label>
                </b-col>
                <b-col cols="8" sm="9">
                    <b-form-input id="phone" placeholder="###-###-####" type="tel" v-model="phone"></b-form-input><span class="validity"></span>
                </b-col>
            </b-row>

            <b-row v-if="tagKeys.length > 0" class="form-row" align-h="center" align-v="center">
                <b-col cols="4" sm="3">
                    <label for="tags">Tags <span style="font-size:12px;">(Optional)</span> </label>
                </b-col>
                <b-col cols="8" sm="9">

                    <b-form-select id="tags" size="sm" :options="tagKeys" v-model="tags"></b-form-select>
                </b-col>
            </b-row>

            <b-row class="form-row" align-h="center" align-v="center">
                <b-col cols="4" sm="3">
                    <label for="note">Notes</label>
                </b-col>
                <b-col cols="8" sm="9">
                    <b-form-textarea id="note" placeholder="Optional (Max length of 35 characters)" v-model="notes"></b-form-textarea>

                </b-col>

            </b-row>

            <b-row class="form-row" align-h="start" align-v="center">

                <b-col cols="4" sm="3">

                </b-col>
                <b-col style="text-align: left;" cols="8" sm="9">
                <b-form-checkbox
                id="checkbox-1"
                v-model="marketing"
                name="checkbox-1"
                :value="true"
                :unchecked-value="false"
                >
                Customer would like to OPT-INTO your marketing text messages.
                </b-form-checkbox>
                  </b-col>
            </b-row>

            <b-row class="mt-4" align-h="center" align-v="center">
                <b-col cols="3" sm="2" md="2" lg="1">
                    <b-btn class="form-btn submit-btn" :disabled="!validateForm" @click="submitOrder">Add</b-btn>
                </b-col>
                <b-col cols="3" sm="2" md="2" lg="1">
                    <b-btn class="form-btn cancel-btn" @click="cancelOrder">Cancel</b-btn>
                </b-col>
            </b-row>
        </div>

        <div v-if="!findCustomer" class="order-form">

            <h1>Customer Phone Number</h1>


            <b-row class="form-row" align-h="center" align-v="center">
                <b-col cols="4" sm="3">
                    <label for="phone">Phone</label>
                </b-col>
                <b-col cols="8" sm="9">
                    <b-form-input id="phone" placeholder="###-###-####" type="tel" v-model="phone"></b-form-input>
                </b-col>
            </b-row>

            <b-row class="mt-4" align-h="center" align-v="center">
                <b-col cols="3" sm="2" md="2" lg="1">
                    <b-btn class="form-btn submit-btn" :disabled="!validateFindCustomer" @click="submitFindCustomer">Next</b-btn>
                </b-col>
                <b-col cols="3" sm="2" md="2" lg="1">
                    <b-btn class="form-btn cancel-btn" @click="cancelOrder">Cancel</b-btn>
                </b-col>
            </b-row>
        </div>
    </b-container>
</template>

<script>
var moment = require('moment');
import Loader from "../../components/Loader"
import { db } from '@/main'
import firebase from 'firebase'
import axios from 'axios'
export default {
    components: {
        Loader
    },
    data() {
        return {
            business: '',
            time: '',
            date: '',
            customer: '',
            phone: '',
            tags: '',
            notes: '',
            addOrderApi: 'https://us-central1-readytextme.cloudfunctions.net/addOrder',
            loader: false,
            moment: moment,
            tagKeys: [],
            marketing: false,
            findCustomerApi: 'https://us-central1-readytextme.cloudfunctions.net/getCustomersLastOrder',
            hasCustomer: false,
            findCustomer: false
        }
    },

    async created() {
        const userDoc = await db.collection('users').doc(firebase.auth().currentUser.uid).get();
        const business = userDoc.data().business;
        this.business = business;

        const businessSnapshot = await db.collection('businesses').doc(business).onSnapshot(async (docc) => {
                this.tagKeys =  Object.keys(docc.data().tags);
            })
    },
    methods: {
        async submitOrder () {
            // method to submit new order
            this.loader = true;

            const startTime = this.moment().format('DD-MM-YYYY hh:mm:ss A');
            // object to send api
            const obj = {
                 'business': this.business,
                 'startTime': startTime,
                 'customer': this.customer,
                 'tags': this.tags,
                 'note': this.notes,
                 'status': 'open',
                 'phone': this.phone,
                 'marketingOpt': this.marketing
            }

            // console.log(obj);
            // request api to create new order
            try {

                await axios.post(
                    this.addOrderApi,
                    obj,
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        },
                    }
                )
                this.$router.push({path:'/open'});
                this.loader = false;
                // if (response.status == '200') {
                // }
                console.log('order created');
            } catch (error) {
                console.log(error);
                this.loader = false;
            }
        },

        async submitFindCustomer () {
            // method to find customer for auto fill
            this.loader = true;

            // object to send api
            const obj = {
                 'business': this.business,
                 'phone': this.phone,
            }

            // console.log(obj);
            // request api to create new order
            try {

                const customerDetails = await axios.post(
                    this.findCustomerApi,
                    obj,
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        },
                    }
                )
                this.loader = false;
                // if (response.status == '200') {
                // }
                // console.log('customer found');
                // console.log(customerDetails.data);
                // this.phone = customerDetails.data.phone;

                // set vars with return data from api
                this.customer = customerDetails.data.customer;
                this.tags = customerDetails.data.tags;
                this.marketing = customerDetails.data.marketingOpt;
                this.findCustomer = true;
            } catch (error) {
                console.log(error);
                this.loader = false;
                this.findCustomer = true;
            }
        },

        cancelOrder () {
            // method to re-route back to open orders page
            this.$router.push({path:'/open'});
        },


    },
    computed: {
        validateForm () {
            // console.log("validate");
            if (this.customer == '') {
                return false;
            } else if (this.phone == '') {
                return false;
            } else if (this.notes.length != 0 && this.notes.length > 35) {
                return false;
            } else {
                return true;
            }
        },

        validateFindCustomer () {
            if (this.phone == '') {
                return false;
            } else {
                return true;
            }
        }
    },
}
</script>


<style scoped>
    .add-order {
        padding-top: 100px;
    }

    .order-form {
        border: 1px solid #efefef;
        padding: 20px;
        border-radius: 12px;
        background: #ffffff;
        box-shadow: 0px 1px 8px 1px #efefef;
    }

    .form-row {
        padding: 10px 0px;
    }

    .form-btn {

    }


    .loader {
        position: fixed;
        width: 350px;
        height: 350px;
        z-index: 100;
        padding-top: 70px;
        /* top: 0; */
        bottom: 30%;
        left: 50%;
        transform: translateX(-50%);
        background-color: #c0c0c0;
        border-radius: 5px;
        transition: all 0.8s ease;
    }

    .marketing-checkbox {
        margin-left: 100px;
    }
</style>
